import { sortBy } from 'lodash';

import { Deliverable } from '../generated/graphql';
import { toJSDate } from './datetime';

export const getLatestDeliverable = <D extends Pick<Deliverable, 'createdAt'>>(modification_request: {
  deliverables: ReadonlyArray<D>;
}): D | undefined => {
  if (modification_request.deliverables.length == 0) return;
  return sortBy(modification_request.deliverables, (a: D) => -toJSDate(a.createdAt).valueOf())[0];
};
